var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogout = function SvgLogout(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9406 6.91278L12.1389 5.11111L5.75 11.5L12.1389 17.8889L13.9406 16.0872L10.6439 12.7778L23 12.7778L23 10.2222L10.6439 10.2222L13.9406 6.91278ZM2.55555 23L20.4444 23C21.8628 23 23 21.85 23 20.4444L23 15.3333L20.4444 15.3333L20.4444 20.4444L2.55555 20.4444L2.55556 2.55556L20.4444 2.55556L20.4444 7.66667L23 7.66667L23 2.55556C23 1.15 21.8628 1.80793e-06 20.4444 1.68393e-06L2.55556 1.20038e-07C1.15 -2.83924e-09 2.8389e-09 1.15 -1.20039e-07 2.55556L-1.68393e-06 20.4444C-1.80681e-06 21.85 1.15 23 2.55555 23Z",
    fill: "black"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogout);
export default ForwardRef;